export function createPromiseQueue(concurrency = 1) {
  let active = 0;
  const pending = [];

  function run({ fn, resolve, reject }) {
    active += 1;
    fn().then(resolve, reject).finally(() => {
      active -= 1;
      next();
    });
  }

  function next() {
    while (pending.length > 0 && active < concurrency) {
      run(pending.shift());
    }
  }

  return {
    enqueue(fn) {
      return new Promise((resolve, reject) => {
        pending.push({ fn, resolve, reject });
        next();
      });
    },
    clear() {
      pending.length = 0;
    },
  };
}
